export default "{\n    \"parentHeading\": \"Jobs\",\n    \"pageTitle\": \"Create Job\",\n    \"newJobTitle\": \"Create New Job\"\n}\n"